export default `"iso","icon","unicode","name"
"ad","🇦🇩","1f1e6-1f1e9","Andorra"
"ae","🇦🇪","1f1e6-1f1ea","United Arab Emirates"
"af","🇦🇫","1f1e6-1f1eb","Afghanistan"
"ag","🇦🇬","1f1e6-1f1ec","Antigua and Barbuda"
"ai","🇦🇮","1f1e6-1f1ee","Anguilla"
"al","🇦🇱","1f1e6-1f1f1","Albania"
"am","🇦🇲","1f1e6-1f1f2","Armenia"
"ao","🇦🇴","1f1e6-1f1f4","Angola"
"aq","🇦🇶","1f1e6-1f1f6","Antarctica"
"ar","🇦🇷","1f1e6-1f1f7","Argentina"
"as","🇦🇸","1f1e6-1f1f8","American Samoa"
"at","🇦🇹","1f1e6-1f1f9","Austria"
"au","🇦🇺","1f1e6-1f1fa","Australia"
"aw","🇦🇼","1f1e6-1f1fc","Aruba"
"ax","🇦🇽","1f1e6-1f1fd","Åland Islands"
"az","🇦🇿","1f1e6-1f1ff","Azerbaijan"
"ba","🇧🇦","1f1e7-1f1e6","Bosnia and Herzegovina"
"bb","🇧🇧","1f1e7-1f1e7","Barbados"
"bd","🇧🇩","1f1e7-1f1e9","Bangladesh"
"be","🇧🇪","1f1e7-1f1ea","Belgium"
"bf","🇧🇫","1f1e7-1f1eb","Burkina Faso"
"bg","🇧🇬","1f1e7-1f1ec","Bulgaria"
"bh","🇧🇭","1f1e7-1f1ed","Bahrain"
"bi","🇧🇮","1f1e7-1f1ee","Burundi"
"bj","🇧🇯","1f1e7-1f1ef","Benin"
"bm","🇧🇲","1f1e7-1f1f2","Bermuda"
"bn","🇧🇳","1f1e7-1f1f3","Brunei Darussalam"
"bo","🇧🇴","1f1e7-1f1f4","Bolivia"
"br","🇧🇷","1f1e7-1f1f7","Brazil"
"bs","🇧🇸","1f1e7-1f1f8","Bahamas"
"bt","🇧🇹","1f1e7-1f1f9","Bhutan"
"bw","🇧🇼","1f1e7-1f1fc","Botswana"
"by","🇧🇾","1f1e7-1f1fe","Belarus"
"bz","🇧🇿","1f1e7-1f1ff","Belize"
"ca","🇨🇦","1f1e8-1f1e6","Canada"
"cc","🇨🇨","1f1e8-1f1e8","Cocos (Keeling) Islands"
"cd","🇨🇩","1f1e8-1f1e9","Democratic Republic of the Congo"
"cf","🇨🇫","1f1e8-1f1eb","Central African Republic"
"cg","🇨🇬","1f1e8-1f1ec","Congo"
"ch","🇨🇭","1f1e8-1f1ed","Switzerland"
"ci","🇨🇮","1f1e8-1f1ee","Côte D'Ivoire"
"ck","🇨🇰","1f1e8-1f1f0","Cook Islands"
"cl","🇨🇱","1f1e8-1f1f1","Chile"
"cm","🇨🇲","1f1e8-1f1f2","Cameroon"
"cn","🇨🇳","1f1e8-1f1f3","China"
"co","🇨🇴","1f1e8-1f1f4","Colombia"
"cr","🇨🇷","1f1e8-1f1f7","Costa Rica"
"cu","🇨🇺","1f1e8-1f1fa","Cuba"
"cv","🇨🇻","1f1e8-1f1fb","Cape Verde"
"cw","🇨🇼","1f1e8-1f1fc","Curaçao"
"cx","🇨🇽","1f1e8-1f1fd","Christmas Island"
"cy","🇨🇾","1f1e8-1f1fe","Cyprus"
"cz","🇨🇿","1f1e8-1f1ff","Czech Republic"
"de","🇩🇪","1f1e9-1f1ea","Germany"
"dj","🇩🇯","1f1e9-1f1ef","Djibouti"
"dk","🇩🇰","1f1e9-1f1f0","Denmark"
"dm","🇩🇲","1f1e9-1f1f2","Dominica"
"do","🇩🇴","1f1e9-1f1f4","Dominican Republic"
"dz","🇩🇿","1f1e9-1f1ff","Algeria"
"ec","🇪🇨","1f1ea-1f1e8","Ecuador"
"ee","🇪🇪","1f1ea-1f1ea","Estonia"
"eg","🇪🇬","1f1ea-1f1ec","Egypt"
"eh","🇪🇭","1f1ea-1f1ed","Western Sahara"
"er","🇪🇷","1f1ea-1f1f7","Eritrea"
"es","🇪🇸","1f1ea-1f1f8","Spain"
"et","🇪🇹","1f1ea-1f1f9","Ethiopia"
"fi","🇫🇮","1f1eb-1f1ee","Finland"
"fj","🇫🇯","1f1eb-1f1ef","Fiji"
"fk","🇫🇰","1f1eb-1f1f0","Falkland Islands (Malvinas)"
"fm","🇫🇲","1f1eb-1f1f2","Micronesia"
"fo","🇫🇴","1f1eb-1f1f4","Faroe Islands"
"fr","🇫🇷","1f1eb-1f1f7","France"
"ga","🇬🇦","1f1ec-1f1e6","Gabon"
"gb","🇬🇧","1f1ec-1f1e7","United Kingdom"
"gd","🇬🇩","1f1ec-1f1e9","Grenada"
"ge","🇬🇪","1f1ec-1f1ea","Georgia"
"gf","🇬🇫","1f1ec-1f1eb","French Guiana"
"gg","🇬🇬","1f1ec-1f1ec","Guernsey"
"gh","🇬🇭","1f1ec-1f1ed","Ghana"
"gi","🇬🇮","1f1ec-1f1ee","Gibraltar"
"gl","🇬🇱","1f1ec-1f1f1","Greenland"
"gm","🇬🇲","1f1ec-1f1f2","Gambia"
"gn","🇬🇳","1f1ec-1f1f3","Guinea"
"gp","🇬🇵","1f1ec-1f1f5","Guadeloupe"
"gq","🇬🇶","1f1ec-1f1f6","Equatorial Guinea"
"gr","🇬🇷","1f1ec-1f1f7","Greece"
"gs","🇬🇸","1f1ec-1f1f8","South Georgia"
"gt","🇬🇹","1f1ec-1f1f9","Guatemala"
"gw","🇬🇼","1f1ec-1f1fc","Guinea-Bissau"
"gy","🇬🇾","1f1ec-1f1fe","Guyana"
"hk","🇭🇰","1f1ed-1f1f0","Hong Kong"
"hn","🇭🇳","1f1ed-1f1f3","Honduras"
"hr","🇭🇷","1f1ed-1f1f7","Croatia"
"ht","🇭🇹","1f1ed-1f1f9","Haiti"
"hu","🇭🇺","1f1ed-1f1fa","Hungary"
"id","🇮🇩","1f1ee-1f1e9","Indonesia"
"ie","🇮🇪","1f1ee-1f1ea","Ireland"
"im","🇮🇲","1f1ee-1f1f2","Isle of Man"
"in","🇮🇳","1f1ee-1f1f3","India"
"io","🇮🇴","1f1ee-1f1f4","British Indian Ocean Territory"
"iq","🇮🇶","1f1ee-1f1f6","Iraq"
"ir","🇮🇷","1f1ee-1f1f7","Iran"
"is","🇮🇸","1f1ee-1f1f8","Iceland"
"it","🇮🇹","1f1ee-1f1f9","Italy"
"je","🇯🇪","1f1ef-1f1ea","Jersey"
"jm","🇯🇲","1f1ef-1f1f2","Jamaica"
"jo","🇯🇴","1f1ef-1f1f4","Jordan"
"jp","🇯🇵","1f1ef-1f1f5","Japan"
"ke","🇰🇪","1f1f0-1f1ea","Kenya"
"kg","🇰🇬","1f1f0-1f1ec","Kyrgyzstan"
"kh","🇰🇭","1f1f0-1f1ed","Cambodia"
"ki","🇰🇮","1f1f0-1f1ee","Kiribati"
"km","🇰🇲","1f1f0-1f1f2","Comoros"
"kn","🇰🇳","1f1f0-1f1f3","Saint Kitts and Nevis"
"kp","🇰🇵","1f1f0-1f1f5","North Korea"
"kr","🇰🇷","1f1f0-1f1f7","South Korea"
"kw","🇰🇼","1f1f0-1f1fc","Kuwait"
"ky","🇰🇾","1f1f0-1f1fe","Cayman Islands"
"kz","🇰🇿","1f1f0-1f1ff","Kazakhstan"
"la","🇱🇦","1f1f1-1f1e6","Lao People's Democratic Republic"
"lb","🇱🇧","1f1f1-1f1e7","Lebanon"
"lc","🇱🇨","1f1f1-1f1e8","Saint Lucia"
"li","🇱🇮","1f1f1-1f1ee","Liechtenstein"
"lk","🇱🇰","1f1f1-1f1f0","Sri Lanka"
"lr","🇱🇷","1f1f1-1f1f7","Liberia"
"ls","🇱🇸","1f1f1-1f1f8","Lesotho"
"lt","🇱🇹","1f1f1-1f1f9","Lithuania"
"lu","🇱🇺","1f1f1-1f1fa","Luxembourg"
"lv","🇱🇻","1f1f1-1f1fb","Latvia"
"ly","🇱🇾","1f1f1-1f1fe","Libya"
"ma","🇲🇦","1f1f2-1f1e6","Morocco"
"mc","🇲🇨","1f1f2-1f1e8","Monaco"
"md","🇲🇩","1f1f2-1f1e9","Moldova"
"me","🇲🇪","1f1f2-1f1ea","Montenegro"
"mg","🇲🇬","1f1f2-1f1ec","Madagascar"
"mh","🇲🇭","1f1f2-1f1ed","Marshall Islands"
"mk","🇲🇰","1f1f2-1f1f0","Macedonia"
"ml","🇲🇱","1f1f2-1f1f1","Mali"
"mm","🇲🇲","1f1f2-1f1f2","Myanmar"
"mn","🇲🇳","1f1f2-1f1f3","Mongolia"
"mo","🇲🇴","1f1f2-1f1f4","Macao"
"mp","🇲🇵","1f1f2-1f1f5","Northern Mariana Islands"
"mr","🇲🇷","1f1f2-1f1f7","Mauritania"
"ms","🇲🇸","1f1f2-1f1f8","Montserrat"
"mt","🇲🇹","1f1f2-1f1f9","Malta"
"mu","🇲🇺","1f1f2-1f1fa","Mauritius"
"mv","🇲🇻","1f1f2-1f1fb","Maldives"
"mw","🇲🇼","1f1f2-1f1fc","Malawi"
"mx","🇲🇽","1f1f2-1f1fd","Mexico"
"my","🇲🇾","1f1f2-1f1fe","Malaysia"
"mz","🇲🇿","1f1f2-1f1ff","Mozambique"
"na","🇳🇦","1f1f3-1f1e6","Namibia"
"nc","🇳🇨","1f1f3-1f1e8","New Caledonia"
"ne","🇳🇪","1f1f3-1f1ea","Niger"
"nf","🇳🇫","1f1f3-1f1eb","Norfolk Island"
"ng","🇳🇬","1f1f3-1f1ec","Nigeria"
"ni","🇳🇮","1f1f3-1f1ee","Nicaragua"
"nl","🇳🇱","1f1f3-1f1f1","Netherlands"
"no","🇳🇴","1f1f3-1f1f4","Norway"
"np","🇳🇵","1f1f3-1f1f5","Nepal"
"nr","🇳🇷","1f1f3-1f1f7","Nauru"
"nu","🇳🇺","1f1f3-1f1fa","Niue"
"nz","🇳🇿","1f1f3-1f1ff","New Zealand"
"om","🇴🇲","1f1f4-1f1f2","Oman"
"pa","🇵🇦","1f1f5-1f1e6","Panama"
"pe","🇵🇪","1f1f5-1f1ea","Peru"
"pf","🇵🇫","1f1f5-1f1eb","French Polynesia"
"pg","🇵🇬","1f1f5-1f1ec","Papua New Guinea"
"ph","🇵🇭","1f1f5-1f1ed","Philippines"
"pk","🇵🇰","1f1f5-1f1f0","Pakistan"
"pl","🇵🇱","1f1f5-1f1f1","Poland"
"pm","🇵🇲","1f1f5-1f1f2","Saint Pierre and Miquelon"
"pn","🇵🇳","1f1f5-1f1f3","Pitcairn"
"pr","🇵🇷","1f1f5-1f1f7","Puerto Rico"
"ps","🇵🇸","1f1f5-1f1f8","Palestine"
"pt","🇵🇹","1f1f5-1f1f9","Portugal"
"pw","🇵🇼","1f1f5-1f1fc","Palau"
"py","🇵🇾","1f1f5-1f1fe","Paraguay"
"qa","🇶🇦","1f1f6-1f1e6","Qatar"
"ro","🇷🇴","1f1f7-1f1f4","Romania"
"rs","🇷🇸","1f1f7-1f1f8","Serbia"
"ru","🇷🇺","1f1f7-1f1fa","Russia"
"rw","🇷🇼","1f1f7-1f1fc","Rwanda"
"sa","🇸🇦","1f1f8-1f1e6","Saudi Arabia"
"sb","🇸🇧","1f1f8-1f1e7","Solomon Islands"
"sc","🇸🇨","1f1f8-1f1e8","Seychelles"
"sd","🇸🇩","1f1f8-1f1e9","Sudan"
"se","🇸🇪","1f1f8-1f1ea","Sweden"
"sg","🇸🇬","1f1f8-1f1ec","Singapore"
"sh","🇸🇭","1f1f8-1f1ed","Saint Helena, Ascension and Tristan Da Cunha"
"si","🇸🇮","1f1f8-1f1ee","Slovenia"
"sk","🇸🇰","1f1f8-1f1f0","Slovakia"
"sl","🇸🇱","1f1f8-1f1f1","Sierra Leone"
"sm","🇸🇲","1f1f8-1f1f2","San Marino"
"sn","🇸🇳","1f1f8-1f1f3","Senegal"
"so","🇸🇴","1f1f8-1f1f4","Somalia"
"sr","🇸🇷","1f1f8-1f1f7","Suriname"
"ss","🇸🇸","1f1f8-1f1f8","South Sudan"
"st","🇸🇹","1f1f8-1f1f9","Sao Tome and Principe"
"sv","🇸🇻","1f1f8-1f1fb","El Salvador"
"sx","🇸🇽","1f1f8-1f1fd","Sint Maarten (Dutch Part)"
"sy","🇸🇾","1f1f8-1f1fe","Syrian Arab Republic"
"sz","🇸🇿","1f1f8-1f1ff","Swaziland"
"tc","🇹🇨","1f1f9-1f1e8","Turks and Caicos Islands"
"td","🇹🇩","1f1f9-1f1e9","Chad"
"tg","🇹🇬","1f1f9-1f1ec","Togo"
"th","🇹🇭","1f1f9-1f1ed","Thailand"
"tj","🇹🇯","1f1f9-1f1ef","Tajikistan"
"tk","🇹🇰","1f1f9-1f1f0","Tokelau"
"tl","🇹🇱","1f1f9-1f1f1","Timor-Leste"
"tm","🇹🇲","1f1f9-1f1f2","Turkmenistan"
"tn","🇹🇳","1f1f9-1f1f3","Tunisia"
"to","🇹🇴","1f1f9-1f1f4","Tonga"
"tr","🇹🇷","1f1f9-1f1f7","Turkey"
"tt","🇹🇹","1f1f9-1f1f9","Trinidad and Tobago"
"tv","🇹🇻","1f1f9-1f1fb","Tuvalu"
"tw","🇹🇼","1f1f9-1f1fc","Taiwan"
"tz","🇹🇿","1f1f9-1f1ff","Tanzania"
"ua","🇺🇦","1f1fa-1f1e6","Ukraine"
"ug","🇺🇬","1f1fa-1f1ec","Uganda"
"us","🇺🇸","1f1fa-1f1f8","United States of America"
"uy","🇺🇾","1f1fa-1f1fe","Uruguay"
"uz","🇺🇿","1f1fa-1f1ff","Uzbekistan"
"va","🇻🇦","1f1fb-1f1e6","Vatican City"
"vc","🇻🇨","1f1fb-1f1e8","Saint Vincent and The Grenadines"
"ve","🇻🇪","1f1fb-1f1ea","Venezuela"
"vg","🇻🇬","1f1fb-1f1ec","Virgin Islands, British"
"vi","🇻🇮","1f1fb-1f1ee","Virgin Islands, U.S."
"vn","🇻🇳","1f1fb-1f1f3","Viet Nam"
"vu","🇻🇺","1f1fb-1f1fa","Vanuatu"
"wf","🇼🇫","1f1fc-1f1eb","Wallis and Futuna"
"ws","🇼🇸","1f1fc-1f1f8","Samoa"
"ye","🇾🇪","1f1fe-1f1ea","Yemen"
"za","🇿🇦","1f1ff-1f1e6","South Africa"
"zm","🇿🇲","1f1ff-1f1f2","Zambia"
"zw","🇿🇼","1f1ff-1f1fc","Zimbabwe"`